import { ref, watch } from "vue";

import { useDelayedAction } from "./useDelayedAction";

const HIGHLIGHT_DURATION_MS = 1_000;

/**
 * Briefly flags `highlighted` whenever `source` changes to a truthy value, then
 * clears it after a short delay. Used to flash a chip when its value updates (eg.
 * a link count changing after a drag-and-drop). Pair with the `highlight-on-change`
 * SCSS mixin, which styles the `.highlighted` class this drives.
 */
export function useHighlightOnChange(source: () => unknown) {
  const highlighted = ref(false);

  const [clearAfterDelay] = useDelayedAction(() => {
    highlighted.value = false;
  }, HIGHLIGHT_DURATION_MS);

  watch(source, (value) => {
    if (!value) return;
    highlighted.value = true;
    clearAfterDelay();
  });

  return { highlighted };
}
